import {createSlice} from '@reduxjs/toolkit'

export const projectSlice = createSlice({
    name: 'project',
    initialState: {
        project_type: null,
    },
    reducers: {
        setProjectType: (state, action) => {
            state.project_type = action.payload
        },
    },
})

export const { setProjectType } = projectSlice.actions
export default projectSlice.reducer
